/**
 * /tenants/$slug/access-governance/approvers — the "Approvers" page: who can act on
 * governance requests. Two sections on one page (UX review merged the former separate
 * "Delegated admins" tab in here): the approver POOLS (recovery + access eligibility)
 * and DELEGATED ADMINISTRATORS (GDAP standing grants).
 *
 * The delegated-admins filter (?include_revoked) lives here now so the URL stays the
 * single source of truth for that list state. .catch(false) tolerates garbage values
 * (?include_revoked=foo) without 500'ing the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccessGovernanceApproversPage } from "@/features/access-governance-approvers/pages/access-governance-approvers-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/access-governance/approvers",
)({
  component: AccessGovernanceApproversPage,
});
